import { render } from "./ClientLogosPage.vue?vue&type=template&id=3134f706&scoped=true"
import script from "./ClientLogosPage.vue?vue&type=script&lang=js"
export * from "./ClientLogosPage.vue?vue&type=script&lang=js"

import "./ClientLogosPage.vue?vue&type=style&index=0&id=3134f706&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3134f706"]])

export default __exports__